(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.tpTrack) return;
  window.tpTrack = function (ev, data) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: ev };
    if (data) { for (var k in data) { o[k] = data[k]; } }
    window.dataLayer.push(o);
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-tp-event]') : null;
    if (!a) return;
    window.tpTrack(a.getAttribute('data-tp-event'), {
      tp_plek: a.getAttribute('data-tp-plek') || '',
      tp_pagina: location.pathname
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
